// Need to have a types.ts file to avoid circular dependencies
// eslint-disable-next-line eag/no-index
import {
  type ButtonActionProps,
  type DropdownActionProps,
  type ButtonWithTooltipActionProps,
} from 'platform/components';
import {HStackProps, ValueByDevice} from 'platform/foundation';

import {Nullish, TestIdProps} from 'shared/web';

export type EntityHeaderAction =
  | ButtonActionProps
  | DropdownActionProps
  | ButtonWithTooltipActionProps;

export type DropdownPosition = 'start' | 'end';

export type EntityHeaderImageVariant = 'image' | 'compact';

export interface EntityHeaderActionsProps extends TestIdProps {
  actions: EntityHeaderAction[] | Nullish;
  dropdownPosition: DropdownPosition | ValueByDevice<DropdownPosition>;
  maxVisibleActions?: number | ValueByDevice<number>;
  shouldStretchActions?: boolean;
  wrap?: HStackProps['wrap'];
}
